$(document).ready(function() {

    /**
     * Syncs search url to pass as query string if the user change any available option
     * @param param
     * @param value
     * @private
     */
    function __syncSearchUrl(param, value){

        $('[data-sync-search-query]').each(function(i, obj) {

            var self = $(this);

            // If it should behave as different type, implement the proper logic.
            if (typeof self.attr('data-behave-as') !== typeof undefined && self.attr('data-behave-as') !== false) {

                if(self.attr('data-behave-as') == 'activeSearchType'){

                    // If its the Authors, we want to set books as active search type.
                    if(value == 'authors'){
                        value = 'books';
                    }
                }
            }

            $(this).attr('href', modules.main.updateUrlParameter($(this).attr('href'), param, value));
        });

    }

    /**
     * Manages the selection of a filter
     * @param active
     * @param label
     * @param count
     * @param allowSort
     * @param provideSuggestions
     * @private
     */
    function __setActiveFilter(active, label, count, allowSort, allowViewChange, provideSuggestions){

        // Manages Filters Tabs and dropdown
        // Unset the current active
        $('.search-filter-types .filter-type').removeClass('active');
        $('.filter-dropdown .actions-items .item').removeClass('active').addClass('option');
        // Set the new active
        $('.search-filter-types .filter-type[data-search-type="'+active+'"]').addClass('active');
        $('.filter-dropdown .actions-items .item[data-search-type="'+active+'"]').addClass('active').removeClass('option');
        $('.filter-dropdown .actions-toggle .filter-name').text(label);
        $('.filter-dropdown .actions-toggle .filter-count').text(count);

        var fixSeparator = false;

        // Manage the Sort Container
        if(allowSort){
            $('[data-search-sort-options]').show();
            fixSeparator = true;
        }else{
            $('[data-search-sort-options]').hide();
        }

        // Manage the Display Container
        if(allowViewChange){
            $('[data-search-view-options]').show();
            fixSeparator = true;
        }else{
            $('[data-search-view-options]').hide();
        }

        if(fixSeparator){
            $('[data-fix-separator]').addClass('actions-separator');
        }else{
            $('[data-fix-separator]').removeClass('actions-separator');
        }

        // Manage the Did you mean container
        if(provideSuggestions){
            $('[data-search-did-you-mean]').show();
        }else{
            $('[data-search-did-you-mean]').hide();
        }

        // Manage Filter results container
        // Hide all the search results containers
        $('.results-container[data-search-type]').hide();
        // Show the right one
        $('.results-container[data-search-type="'+active+'"]').show();
        
        $(".lazy:not(.lazy-loaded)").lazyload();
    }

    $(document).on('click', '.filter-type', function(e){

        e.preventDefault();

        var clickedFilter = $(this);

        var allowSort = false;
        var allowViewChange = false;
        var activeType = $(this).attr('data-search-type');
        var provideSuggestions = false;
        var label = $(this).attr('data-filter-label');
        var count = $(this).attr('data-filter-count');

        if (typeof clickedFilter.attr('data-allow-sort') !== typeof undefined && clickedFilter.attr('data-allow-sort') !== false) {
            allowSort = true;
        }

        if (typeof clickedFilter.attr('data-allow-view-change') !== typeof undefined && clickedFilter.attr('data-allow-view-change') !== false) {
            allowViewChange = true;
        }

        if (typeof clickedFilter.attr('data-provide-suggestions') !== typeof undefined && clickedFilter.attr('data-provide-suggestions') !== false) {
            provideSuggestions = true;
        }

        __setActiveFilter(activeType, label, count, allowSort, allowViewChange, provideSuggestions);

        __syncSearchUrl('activeSearchType', activeType);

    });

    $(document).on('click', '[data-search-show-more]', function (e) {

        e.preventDefault();

        var clickedShowMoreBtn = $(this);

        var container = $('.results-container[data-search-type="'+clickedShowMoreBtn.attr('data-search-show-more')+'"]');

        // html with button from current page to be removed
        var removeHtml = clickedShowMoreBtn.closest('.show-more-container');

        var moreBtn = clickedShowMoreBtn;

        var failCallback = function () {
            container.find('.more-search-results-loader').addClass('hidden');
            container.find('.more-search-results-loader-error').removeClass('hidden');
            moreBtn.removeClass('hidden').find('.result-info-button').addClass('error-loading');
        };

        $.ajax({
            url: $(this).attr('href'),
            beforeSend: function (xhr) {
                container.find('.more-search-results-loader').removeClass('hidden');
                container.find('.more-search-results-loader-error').addClass('hidden');
                moreBtn.addClass('hidden').find('.result-info-button').removeClass('error-loading');
            }
        })
        .done(function (data) {
            if(data){
                container.find('.more-search-results-loader').addClass('hidden');
                container.find('.result-info').remove();
                // Manage store results last row
                container.find('.result-row').removeClass('last');
                // Manage generic results last row
                container.find('.product-row-wrapper').removeClass('last');
                container.append(data);
                container.find('.product-row-wrapper:last').addClass('last');
                removeHtml.remove();
                $(".lazy:not(.lazy-loaded)").lazyload();
            }else{
                failCallback();
            }

        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            failCallback()
        });
    });
});